/**
 * @file 首页页面底部使用引导
 * @description 在用户浏览完页面后再做一次引导
 */

import React from 'react'

import Button from 'components/UI/Button'
import { useMobile } from 'hooks/ua'

import styles from './style.less'

export default function UsageGuide() {
  const isMobile = useMobile()
  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>让闲置创造价值</h3>
      <div className={styles.desc}>
        立即接入 NiuLink 平台，让您的闲置资源为您工作，开启一份稳定的额外收入。
      </div>
      <Button type="primary" size={isMobile ? 'default' : 'large'} className={styles.btn} href="/cooperations#apply">立即参与</Button>
    </div>
  )
}
